<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>测试号消费明细</span>
        <el-button type="text" @click="$router.push('/admin/dashboard')">返回仪表盘</el-button>
      </div>
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="测试号消费实收为 0，火山成本照常统计；名义积分仅供参考。"
        class="tip"
      />
      <el-form :inline="true" size="small">
        <el-form-item label="日期">
          <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" :clearable="false" />
        </el-form-item>
        <el-form-item label="排序">
          <el-select v-model="sort" style="width: 140px">
            <el-option label="按时间" value="time" />
            <el-option label="按名义积分" value="credits" />
            <el-option label="按成本" value="cost" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reload">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="createdAt" label="时间" width="170">
          <template slot-scope="{ row }">{{ formatTime(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column prop="nickname" label="用户" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.nickname || row.userId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130" show-overflow-tooltip />
        <el-table-column prop="credits" label="名义积分" width="90" align="right" />
        <el-table-column label="实收" width="90" align="right">
          <template slot-scope="{ row }">{{ formatYuan(row.revenueYuan) }}</template>
        </el-table-column>
        <el-table-column label="火山成本" width="100" align="right">
          <template slot-scope="{ row }">{{ formatYuan(row.costYuan) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="statusType(row.status)">{{ statusLabel(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pricedAs" label="计价" min-width="140" show-overflow-tooltip />
        <el-table-column prop="description" label="说明" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ formatOpsDescription(row.description) }}</template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="onPageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getOpsTest } from '@/api/admin'
import { formatYuan } from '@/utils/dashboardFormat'
import { todayShanghai, formatDateTime, formatOpsDescription } from './opsFormat'

export default {
  name: 'OpsTest',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      date: todayShanghai(),
      sort: 'time'
    }
  },
  created() {
    this.reload()
  },
  methods: {
    formatYuan,
    formatOpsDescription,
    formatTime(value) {
      return formatDateTime(value)
    },
    statusLabel(status) {
      if (status === 'accounted') return '已核算'
      if (status === 'non_volc') return '非火山'
      return '缺刊例'
    },
    statusType(status) {
      if (status === 'accounted') return 'success'
      if (status === 'non_volc') return 'info'
      return 'warning'
    },
    async reload() {
      this.page = 1
      await this.loadList()
    },
    async loadList() {
      this.loading = true
      try {
        const result = await getOpsTest({
          date: this.date,
          page: this.page,
          size: this.pageSize,
          sort: this.sort
        })
        this.list = result.list || []
        this.total = Number(result.total || 0)
      } catch (e) {
        this.$message.error(e.message || '加载失败')
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    onPageChange(page) {
      this.page = page
      this.loadList()
    }
  }
}
</script>

<style scoped>
.page {
  padding: 8px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tip {
  margin-bottom: 16px;
}
.pager-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
